import { IControlOption } from '@/Interfaces/ControlOption.interface';
import FilterGroupChip from '@/components/Filter/FilterGroupChip';
import LoadingBackdrop from '@/components/Grid/LoadingBackdrop';
import TvIcon from '@/components/Icons/TvIcon';
import SearchInput from '@/components/SearchInput';
import SearchSelect from '@/components/Select/SearchSelect';
import { Add, ArrowDropDown } from '@mui/icons-material';
import { Button, OutlinedInput, outlinedInputClasses } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import { ChangeEvent, useCallback, useState } from 'react';

interface IProps {
  setQuickFilter: (terms: string[]) => void;
  onCreateNewClick: () => void;
  orgs: IControlOption[];
  setOrgFilter: (ids: number[]) => void;
  loading: boolean;
}

const ToolBar = ({ setQuickFilter, onCreateNewClick, orgs, setOrgFilter, loading }: IProps) => {
  const [filterValue, setFilterValue] = useState<string>('');
  const [selectedOrgs, setSelectedOrgs] = useState<IControlOption[]>([]);
  const onInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setFilterValue(value);
      setQuickFilter(value?.split(' ') || []);
    },
    [setQuickFilter],
  );

  const onOrgSelect = useCallback(
    (incomingOrgs: IControlOption[]) => {
      setSelectedOrgs(incomingOrgs);
      setOrgFilter(incomingOrgs.map(org => org.value));
    },
    [setOrgFilter],
  );

  return (
    <GridToolbarContainer sx={{ padding: 0 }}>
      <div className='py-[24px] px-[30px] flex items-center justify-between relative w-full'>
        <div className='flex gap-[12px]'>
          <SearchInput placeholder='Search..' value={filterValue} onChange={onInputChange} />
          <SearchSelect
            value={selectedOrgs}
            onChange={onOrgSelect}
            options={orgs}
            label='Organization'
            renderInput={props => (
              <OutlinedInput
                readOnly
                startAdornment={<TvIcon className='w-[20px] shrink-0' />}
                endAdornment={<ArrowDropDown />}
                placeholder='Organization'
                sx={{
                  height: '37px',
                  width: '180px',
                  paddingRight: '6px',
                  cursor: 'pointer',
                  [`& .${outlinedInputClasses.input}`]: {
                    paddingLeft: '4px',
                    paddingRight: 0,
                    cursor: 'pointer',
                  },
                }}
                {...props}
              />
            )}
          />
          <FilterGroupChip items={selectedOrgs} type='Organizations' />
        </div>
        <Button variant='contained' onClick={onCreateNewClick}>
          <Add sx={{ width: 16, height: 16, marginRight: '2px' }} />
          <span>Create New</span>
        </Button>
      </div>
      {loading ? <LoadingBackdrop /> : null}
    </GridToolbarContainer>
  );
};

export default ToolBar;
